
export default {
  name: 'TeacherIcon',
  props: {
    classCss: { type: String, default: '' },
  },
}
